import LyRowGroup from './src/index.vue'

LyRowGroup.install = function (Vue) {
    Vue.component(LyRowGroup.name, LyRowGroup)
}

export default LyRowGroup


//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/row-group/index.js
// module id = null
// module chunks = 